import React, { useState, useEffect } from "react"
import { Link, useHistory, useLocation, useParams } from "react-router-dom"
import { Col, Card, CardImg, CardBody, CardTitle, CardText, Spinner } from "reactstrap"
import { ethers } from "ethers"
import { Provider, utils, Wallet, Web3Provider } from "zksync-web3"

import blankLoadingPic from "../../assets/images/blank-loading.png"
import idexoLogo from "../../assets/images/logo-dark.png"
import { useToast } from "../../hooks/toast"

import { useWallet } from "../../libs/useMetaMaskWallet"
import Web3 from "web3"
import LoadingOrErrorCard from "../../Components/LoadingOrErrorCard/LoadingOrErrorCard"
import ConfirmSubmitModal from "../../Components/ConfirmSubmitModal/ConfirmSubmitModal"
import ConnectWallet from "../../Components/ConnectWallet"
import BreadCrumb from "../../Components/BreadCrumb"
import Tooltip from "../../Components/Tooltip"
import IdeaCard from "./IdeaCard"

import ideaAbi from "../../abi/IdeaMarketplace.json"
import igspAbi from "../../abi/StakePoolSimpleCombinedNewFTM.json"

import { networkIcons, flattenTokenGatingNFTs, formatTokenURI } from "../../utils"

const paymasterContractAddress = "0x14086A82F6Ffb6e4b3bddE5ea844F053bEC5143D"
const ideaContractAddress = "0x739307dc5c36B7Fd4d7B42c533c9408c2c565F35"
const stakeContractAddress = "0xD64281B0E63486B48927AC895c22905638fC696c"

const IdeaViewer = () => {
    const web3 = new Web3(window.ethereum)
    const wallet = useWallet()
    const toast = useToast()
    const history = useHistory()
    const location = useLocation()
    const params = useParams()
    // const [isConnectedToWallet, setIsConnectedToWallet] = useState(wallet?.status === "connected")
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    const [ideas, setIdeas] = useState([]) // [{ chain:'bnbchain', tokens:[] }, { chain:'polygon', tokens:[]}, {}, {}, ...]
    const [showLoadingNFTs, setShowLoadingNFTs] = useState(false) // spinner animation for fetching user community nfts
    const [errorMessage, setErrorMessage] = useState("") // error alert fetching user community nfts
    const [isLoading, setIsLoading] = useState(false)

    const [headerText, setHeaderText] = useState("View Ideas From The Marketplace")

    const [modalAlertMessage, setModalAlertMessage] = useState("")
    const [modalAlertColor, setModalAlertColor] = useState("")
    const [disableModalButtons, setDisableModalButtons] = useState(false)
    const [showConfirmLoading, setShowConfirmLoading] = useState(false) // loading animation after clicking "confirm" button
    const [activeCardId, setActiveCardId] = useState(null)
    const [stakeIds, setStakeIds] = useState([])

    const rpcUrl = "https://mainnet.era.zksync.io"
    // const chainId = 324

    const provider = new Provider(rpcUrl, chainId)
    const [chainId, setChainId] = useState(undefined)
    const [account, setAccount] = useState(0)

    // TO DO: move to utils.js for reuse/DRY
    const handleCopyClick = (e, link) => {
        e.stopPropagation()
        navigator.clipboard.writeText(link?.replace("×", "x"))
        toast.addSuccess(`Token URI ${formatTokenURI(link)} is copied to clipboard.`)
    }

    const handleCardClick = (id) => {
        // setActiveCardId(id)
        console.log("id is: " + id)
        if (id >= 1) {
            id = id + 1
            const idea = ideas[id]
            history.push(`/ideaviewer/${idea.id}`, { idea, id })
        }
        const idea = ideas[id]
        history.push(`/ideaviewer/${idea.id}`, { idea, id })
    }

    const handleBack = () => {
        setActiveCardId(null)
    }

    const getIdeaContract = (contractAddress) => {
        return new ethers.Contract(contractAddress, ideaAbi, provider)
    }

    const getIdeas = async (ideaContractAddress) => {
        try {
            setIsLoading(true)
            const ideaContract = getIdeaContract(ideaContractAddress)
            // console.log("nft contract: " + JSON.stringify(nftContract))
            const ideaCount = await ideaContract._ideaIds()
            const ideaCountAdjusted = ideaCount + 1
            // const nftName = await getNFTContract(contractAddress).name()
            // const isHolder = await nftContract.isHolder(walletAddress)
            console.log("idea count: " + ideaCount)

            const ideas = []

            for (let idea = 2; idea <= ideaCount; idea++) {
                const ideaIdStr = idea.toString()
                console.log("token id: " + ideaIdStr)
                try {
                    const ideaInfo = await ideaContract.ideas(idea)
                    console.log("ideaInfo: " + ideaInfo)

                    ideas.push({
                        id: ideaIdStr,
                        name: ideaInfo[0],
                        description: ideaInfo[1],
                        numVotes: ideaInfo[2].toString(),
                        imageURL: ideaInfo[3],
                        creator: ideaInfo[4]
                    })
                    console.log("ideas: " + JSON.stringify(ideas))
                } catch (error) {
                    console.error("Error fetching metadata for ideaId " + idea + ": ", error)
                }
            }
            setIsLoading(false)
            return ideas
        } catch (error) {
            console.error("Error fetching ideas:", error)
            return []
        }
    }

    const refreshIdeas = async () => {
        const fetchIdeas = await getIdeas(ideaContractAddress)
        setIdeas(fetchIdeas)
    }

    const getStakeIds = async () => {
        try {
            if (wallet.account) {
                const stakingContract = new ethers.Contract(stakeContractAddress, igspAbi, provider)
                const stakerIds = await stakingContract.getStakeTokenIds(wallet.account)
                console.log("staker ids: " + stakerIds)
                setStakeIds(stakerIds)
            } else {
                console.log("wallet not connected")
            }
        } catch (error) {
            console.error("Error fetching ids:", error)
            return []
        }
    }

    const updateConnection = () => {
        const x = wallet.status === "connected"
        setIsConnectedToWallet(x)
        return x
    }

    useEffect(() => {
        ;(async () => {
            setIsConnectedToWallet(wallet.status === "connected")
            if (wallet.account) {
                try {
                    setAccount(wallet.account)
                    setChainId(wallet.chainId)
                    const fetchIdeas = await getIdeas(ideaContractAddress)
                    setIdeas(fetchIdeas)
                    await getStakeIds()
                    // console.log('user nfts: ' + JSON.stringify(fetchedUserNFTs))
                } catch (err) {
                    console.log(err)
                }
            }
        })()
    }, [wallet, wallet.account])

    useEffect(() => {
        // Extract the NFT ID or other identifying parameter from the URL
        const { id } = params // Assuming the route param is named `id`
        // const numericId = parseInt(id, 10); // Convert to a number

        // Find the index of the NFT based on the ID extracted from the URL
        const ideaIndex = ideas.findIndex((idea) => idea.id.toString() === id)
        // console.log("id: " + id + " nftIndex: " + nftIndex)

        if (ideaIndex >= 0) {
            setActiveCardId(ideaIndex)
        } else {
            setActiveCardId(null) // Reset or handle the case where the NFT is not found
        }
    }, [location, params, ideas]) // React to changes in location or NFT list

    // useEffect(async () => {
    //     if (updateConnection() && wallet.account) {
    //         const fetchedUserNFTs = await getUserTokens(realContractAddress, wallet.account)
    //         setUserNFTs(fetchedUserNFTs)
    //         console.log('user nfts: ' + JSON.stringify(fetchedUserNFTs))
    //     }
    // }, [wallet.account])

    return (
        <div className="content token-gating">
            {/* OLD BreadCrumb */}
            {/* <BreadCrumb current="Token Gating" /> */}
            <BreadCrumb items={["View Ideas"]} />

            {!isConnectedToWallet ? (
                <Card className="token-gating-welcome">
                    <CardBody>
                        <CardTitle className="h3">{headerText}</CardTitle>
                        <CardText>Connect your wallet and your zkSync to view Ideas.</CardText>
                        <CardBody>
                            <ConnectWallet wallet={wallet} onChange={updateConnection} isTokenGating={true} />
                        </CardBody>
                    </CardBody>
                </Card>
            ) : (
                <React.Fragment>
                    <Card className="token-gating-welcome">
                        <CardBody>
                            <CardTitle className="h3">{headerText}</CardTitle>
                            {isLoading ? (
                                // text that shows when card is loading
                                <LoadingOrErrorCard loadingTxt="Checking for Ideas" className="token-gating-loading" />
                            ) : (
                                <React.Fragment>
                                    {errorMessage && (
                                        <LoadingOrErrorCard
                                            // text that shows if there's an error checking the user's nft's
                                            errorTxt={"Error checking for Ideas"}
                                            alertMessage={errorMessage}
                                            className="token-gating-loading"
                                        />
                                    )}

                                    {!ideas?.length && !errorMessage && (
                                        // text that shows if the user has no token gated NFTs
                                        <LoadingOrErrorCard emptyTxt="There are no Ideas" emptyTxt2={""} className="token-gating-loading" />
                                    )}

                                    {ideas?.length >= 1 &&
                                        !errorMessage &&
                                        (activeCardId !== null ? (
                                            <IdeaCard
                                                idea={ideas[activeCardId]}
                                                cardId={ideas[activeCardId].id}
                                                stakeIds={stakeIds.toString()}
                                                refreshIdeas={refreshIdeas}
                                            />
                                        ) : (
                                            <React.Fragment>
                                                <div className="welcome-message">
                                                    <div className="app">Welcome to the idexo Idea Markeplace on zkSync Era</div>
                                                    <div className="app">Below are ideas you can vote on as an idexo general staker</div>
                                                </div>
                                                <div className="token-gating-card-wrap">
                                                    {ideas
                                                        ?.filter((_, idx) => idx !== 1)
                                                        .map((idea, idx) => (
                                                            <Col key={idx} sm="12" md="12" lg="12" xl="12">
                                                                <Card className="clickable-card" id={idea.id} onClick={() => handleCardClick(idx)}>
                                                                    <CardImg top width="100%" src={idea.imageURL} alt="Idea Image" />
                                                                    <CardBody>
                                                                        <CardTitle tag="h5">{idea.name}</CardTitle>
                                                                        <div>Description: {idea.description}</div>
                                                                        <div># of Votes: {idea.numVotes}</div>
                                                                    </CardBody>
                                                                </Card>
                                                            </Col>
                                                        ))}
                                                </div>
                                            </React.Fragment>
                                        ))}
                                </React.Fragment>
                            )}
                        </CardBody>
                    </Card>
                </React.Fragment>
            )}
        </div>
    )
}

export default IdeaViewer
